export default class BannerService {

    constructor(resource, url) {
        this._resource = resource('banner/'+url);
    }

    blocks() {
        return this._resource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de publicacoes.');
            });
    }
}



// WEBPACK FOOTER //
// ./src/domain/bannerService.js